export default __webpack_public_path__ + "static/media/DSCN0366.643e4853.JPG";